export const UNITS = Object.freeze({
  METRIC: {
    velocity: 'kph',
    precipitation: 'cm',
    pressure: 'mBar',
    temperature: '°',
  },
  IMPERIAL: {
    velocity: 'mph',
    precipitation: 'in',
    pressure: 'inHg',
    temperature: '°',
  },
})

export const TEMPERATURE_FIELDS = [
  'temperature',
  'feelsLike',
  'maxFeelsLike',
  'minFeelsLike',
  'maxTemperature',
  'minTemperature',
]

export const VELOCITY_FIELDS = ['windVelocity']

export const PRESSURE_FIELDS = ['pressure']

export const HEIGHT_CM_FIELDS = ['snowFallRate']
export const HEIGHT_MM_FIELDS = ['precipitation']

export const TIME_FIELDS = [
  'startTime',
  'endTime',
  'rise',
  'set',
  'transit',
  'overhead',
  'underfoot',
]

export const SOLARLUNAR_FIELDS = ['solar', 'lunar', 'solarLunar']
